import styled from 'styled-components';
import { COLOR_WHITE } from '../../../assets/styles/colors';
import { BP_MOBILE_MAX } from '../../../assets/styles/breakpoints';
import { SmallTextSC } from '../../typography/small-text';

export default styled.div`
  border-radius: 12px;
  background: ${COLOR_WHITE};
  padding: 20px 32px;
  display: flex;
  flex-flow: row wrap;
  justify-content: flex-start;
  margin-top: 32px;

  .doc-wrap {
    width: calc(100%);
    &:last-child button {
      border-bottom: none;
      padding-bottom: 0px;
    }
    &:first-child button {
      padding-top: 0px;
    }
    button {
      border: none;
      display: flex;
      justify-content: space-between;
      align-items: center;
      flex-direction: row;
      width: calc(100%);
      height: 100%;
      padding: 20px 0;
      border-bottom: 1px solid rgba(47, 46, 65, 0.1);
      background: none;
      &:hover {
        opacity: 0.8;
      }
      &:focus,
      &:active {
        outline: none;
        box-shadow: none;
      }
      svg {
        max-width: 28px;
        min-width: 28px;
      }
      .doc-info-wrap {
        width: 100%;
        display: flex;
        justify-content: space-between;
        align-items: center;
        flex-direction: row;
        gap: 20px;

        .doc-name {
          display: flex;
          flex-direction: column;

          p {
            word-break: break-all;
            text-align: left;
            max-width: 100%;
          }

          ${SmallTextSC} {
            text-align: left;
          }
        }
      }
      .doc-icon {
        padding-right: 20px;
      }
      .doc-date {
        display: flex;
        flex-direction: column;
        text-align: right;
      }
    }
  }

  .pagination-wrap {
    width: 100%;
    padding: 8px 0;
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }

  @media (max-width: ${BP_MOBILE_MAX}px) {
    .doc-wrap {
      button {
        .doc-info-wrap {
          width: 100%;
          display: flex;
          justify-content: flex-start;
          align-items: flex-start;
          flex-direction: column;
          gap: 0px;
        }
        .doc-date {
          text-align: left;
          width: 100%;
          display: flex;
          flex-direction: row;
          gap: 5px;
        }
      }
    }
  }
`;
